import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import _isString from "lodash/isString";
import analytics from "web/script/analytics/analytics";
import globals from "web/script/modules/globals";
import browser from "web/script/utils/browser";
/**
 * Checks if an event is the user trying to open something in a new tab
 */

export function isOpenInNewTab(event) {
  return browser.mac && event.metaKey || !browser.mac && event.ctrlKey;
}
/**
 * A custom hook for tracking analytics events when a link is clicked
 * @param eventCategory The event category
 * @param eventAction The event action
 * @param eventLabel Optional free text label for the event.
 * @param delayPageChange Optional If the click should be delayed until the analytics completes
 * @param eventCustomData Optional information if you need to send customised data.
 * @returns A callback for onClick
 */

export function useClickTracker(eventCategory, eventAction) {
  var eventLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var delayPageChange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var eventCustomData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  // TODO: a) shouldn't this be an exception? b) analytics.event already checks this for us
  if (!(_isString(eventCategory) && _isString(eventAction))) {
    return function () {
      return Promise.resolve();
    };
  }

  return function onClick(event) {
    var action = analytics.event(eventCategory, eventAction, eventLabel, false, eventCustomData);
    var openingInNewTab = isOpenInNewTab(event);

    if (delayPageChange && !openingInNewTab) {
      event.preventDefault();
      var href = event.currentTarget.href;
      action = action.then(function () {
        globals.window.location.href = href;
      });
    }

    return action;
  };
}